import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import ELEMENTS from '~/components/PluginsEditor/components/elements/elementsEnum';
import { UnorderedListElement } from '~/components/PluginsEditor/types';
import serialize from './serialize';

export type Props = RenderElementProps & {
  dataTestId?: string;
  element: UnorderedListElement;
};

const UnorderedList: React.FC<Props> = ({
  dataTestId,
  attributes,
  element,
  children,
}) => (
  <Container data-testid={dataTestId} {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.ul<{}>`
  margin: 0;
`;

export default {
  nodeName: 'UL',
  renderComponent: props => <UnorderedList {...props} />,
  deserialize: () => ({ type: ELEMENTS.UL }),
  serialize,
};
